import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { Link } from 'settle-ui/components/Link/Link'
import { useSnackbars } from 'settle-ui/hooks/useSnackbars/useSnackbars'
import { ApplyPromoCodeDialog } from 'routes/dialogs/ApplyPromoCodeDialog/ApplyPromoCodeDialog'
import { ViewPromoCodeDialog } from 'routes/dialogs/ViewPromoCodeDialog/ViewPromoCodeDialog'
import { logEvent } from 'lib/tracking/segment'
import { useAppliedPromoCodeContext } from 'routes/hooks/useAppliedPromoCodeContext/useAppliedPromoCodeContext'
import * as events from './ApplyPromoCodeLink.events'

interface ApplyPromoCodeLinkProps {
  promoCodeQueryString: Maybe<string>
}

export const ApplyPromoCodeLink: Settle.FC<ApplyPromoCodeLinkProps> = ({ promoCodeQueryString }) => {
  const { t } = useTranslation()
  const { showAlert } = useSnackbars()
  const [applyPromoCodeDialogOpen, setApplyPromoCodeDialogOpen] = useState(Boolean(promoCodeQueryString))
  const [viewPromoCodeDialogOpen, setViewPromoCodeDialogOpen] = useState(false)
  const { setPromoCode, promoCode } = useAppliedPromoCodeContext()

  return (
    <>
      <Link
        color="secondary"
        textAlign="center"
        data-testid="apply-promo-code-link"
        onClick={() => {
          setApplyPromoCodeDialogOpen(true)
          logEvent(events.APPLY_PROMO_CODE_LINK_CLICK, { place: 'onboarding' })
        }}
      >
        {t('onboarding::applyPromoCode')}
      </Link>
      <ApplyPromoCodeDialog
        open={applyPromoCodeDialogOpen}
        promoCode={promoCodeQueryString ?? ''}
        onClose={() => setApplyPromoCodeDialogOpen(false)}
        onSuccess={() => {
          setApplyPromoCodeDialogOpen(false)
          setViewPromoCodeDialogOpen(true)
        }}
      />
      <ViewPromoCodeDialog
        open={viewPromoCodeDialogOpen}
        onClose={() => setViewPromoCodeDialogOpen(false)}
        onProceed={() => {
          setViewPromoCodeDialogOpen(false)
          if (promoCode) {
            setPromoCode({ ...promoCode, applied: true })
            showAlert(t('onboarding::promoCodeApplied'))
          }
        }}
      />
    </>
  )
}
